let searchBlock;
function showHideSearch(show = false) {
    if (typeof searchBlock == 'undefined') searchBlock = $("#searchBlock");
    if (show) {
        searchBlock.show(0);
        searchBlock.find("input[name='text']").val('').blur();
    }
    animateFromTo(searchBlock, animTime / 1000 * 2, { opacity: show ? 0 : 1, y: show ? "-100%" : "0%" }, {
        opacity: show ? 1 : 0, y: show ? "0%" : -searchBlock.find(".topRow").innerHeight(), ease: Power2.easeOut,
        onComplete: () => {
            if (show) {
                searchBlock.find("input[name='text']").attr('autofocus', 'autofocus').focus().click();
            } else {
                searchBlock.removeClass("showResult")
                hideScrollBar(show);
                hold_scroll_page(show);
                searchBlock.hide(0);
            }
        }
    }, show ? animTime / 1000 / 2 : 0);
};

function showSearchResults() {
    const show = true;
    if (typeof searchBlock == 'undefined') searchBlock = $("#searchBlock");
    searchBlock.addClass("showResult")
    hold_scroll_page(show);
    hideScrollBar(show);
    searchBlock.css("display", 'flex')
    searchBlock.find('.searchContent').scrollTop(0);
    searchBlock.find('.searchContent .container').stop(true).fadeTo(0, 0).fadeTo(animTime * 2, 1);
}